import {mapActions, mapGetters} from "vuex";

const ContractFormMixin = {
  data: () => ({
    validated      : null,
    getStateTimeout: 1000,
  }),
  mounted() {
    this.getStateError();
  },
  methods : {
    ...mapActions('contractFormError', [
      'saveValidateResponse',
      'saveErrorMessages',
    ]),
    validate() {
      this.$v.$touch();
      this.validated = !this.$v.$invalid;
    },
    getStateError() {
      if (this.stateValidateResponse || this.stateErrorMessages) {
        setTimeout(() => {
          this.validateResponse = this.stateValidateResponse ?? [];
          this.errorMessages    = this.stateErrorMessages ?? [];
        }, this.getStateTimeout)
      }
    },
  },
  computed: {
    ...mapGetters('contractFormError', {
      stateValidateResponse: 'validateResponse',
      stateErrorMessages   : 'errorMessages',
    }),
  },
  watch   : {
    value: {
      deep: true,
      handler() {
        this.form = this.value;
      }
    },
    form : {
      deep: true,
      handler() {
        this.$emit('input', this.form);
      }
    },
  },
};

export default ContractFormMixin;
